/**
 * Determine whether or not we should fire an arrow key event
 */
export function isElementBlacklisted(activeElement: HTMLElement | null | undefined): boolean {
  return Boolean(
    !activeElement ||
      activeElement.isContentEditable ||
      ['INPUT', 'TEXTAREA'].includes(activeElement.tagName),
  );
}
